import { useMemo } from 'react';
import { EventType } from '~/Models/DTO/Event.model';
import { Theme, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const usePageTitle = ({
  isEditEventGroup,
  eventGroupName = '',
  eventType,
}: {
  isEditEventGroup: boolean;
  eventGroupName?: string;
  eventType: EventType;
}) => {
  const { t } = useTranslation();
  const mobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const pageTitle = useMemo(() => {
    if (mobile || !eventGroupName) {
      if (isEditEventGroup) {
        return t('app.edit');
      }

      return eventType === EventType.FREE_TRAINING
        ? t('event.create.freeTraining')
        : t('event.createClass');
    }
    return `${isEditEventGroup ? t('app.editing') : t('app.title.create')} ${eventGroupName}`;
  }, [mobile, eventType, isEditEventGroup, eventGroupName]);

  return { pageTitle };
};
